var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.332 30.7825C21.598 32.4634 19.7048 32.198 17.8824 31.4018C15.9538 30.5879 14.1845 30.5525 12.1497 31.4018C9.60188 32.4987 8.25718 32.1803 6.73554 30.7825C-1.89885 21.8827 -0.624921 8.32953 9.17724 7.83412C11.5658 7.95797 13.229 9.14343 14.6268 9.24959C16.7146 8.82495 18.714 7.6041 20.9434 7.76334C23.6151 7.97567 25.6321 9.03727 26.9591 10.9482C21.4388 14.2568 22.7481 21.5288 27.8084 23.5636C26.7999 26.2176 25.4906 28.8539 23.3143 30.8002L23.332 30.7825ZM14.4499 7.72796C14.1845 3.78232 17.387 0.526734 21.0672 0.208252C21.5803 4.77316 16.927 8.17029 14.4499 7.72796Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.b84f7ec6a4e1fb54236da93380e91167.svg";
export { ForwardRef as ReactComponent };